"use client";
import React from "react";
import { FaFacebookF, FaInstagram, FaEnvelope } from "react-icons/fa";
import styles from "./footer.module.scss";
import Button from "@/app/components/button/button";

const Footer = () => (
  <footer className={styles.footer}>
    <section className={styles.subscribe}>
      <h4>Subscribe To Newsletter</h4>
      <form onSubmit={(e) => e.preventDefault()}>
        <div>
          <FaEnvelope />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
            aria-required="true"
          />
        </div>

        <Button type="submit">Subscribe</Button>
      </form>
    </section>

    <section className={styles.companyInfo}>
      <div className={styles.logo}>
        <p className={styles.gradientText}>Geer</p>
      </div>
      <address>
        3rd Floor, Maple Plaza, opposite Zenith Mall, Downtown Street, Mumbai{" "}
        <br />
        400001 <br />
        Mon - Sat from 10:00 AM - 6:00 PM IST <br />
        Email: <a href="mailto:st8493510@gmail.com">st8493510@gmail.com</a>{" "}
        <br />
        Portfolio:{" "}
        <a target="_blank" href="https://santosh-gamma.vercel.app/home/">
          santosh-gamma.vercel.app
        </a>{" "}
        <br />
      </address>
      <div className={styles.social}>
        <a href="#!" aria-label="Facebook">
          <FaFacebookF />
        </a>
        <a href="#!" aria-label="Instagram">
          <FaInstagram />
        </a>
      </div>
    </section>

    <nav className={styles.links} aria-label="Footer Navigation">
      {[
        {
          title: "ABOUT",
          items: ["OUR STORY", "BEYOND CONFLICT", "FREE", "CUSTOMER REVIEW"],
        },
        {
          title: "POLICIES",
          items: [
            "TERMS & CONDITIONS",
            "PRIVACY POLICY",
            "FAQ",
            "RETURN & REFUND",
            "SHIPPING POLICY",
          ],
        },
        {
          title: "EDUCATION",
          items: [
            "DIAMOND BUYING GUIDE",
            "LAB GROWN DIAMONDS",
            "RING SIZE CHART",
            "JEWELLERY CARE",
            "BLOG",
          ],
        },
      ].map(({ title, items }) => (
        <div key={title}>
          <h4>{title}</h4>
          <ul>
            {items.map((item) => (
              <li key={item}>
                <strong>{item}</strong>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>

    <hr />
    <div className={styles.portfolio}>
      <a
        href="https://santosh-gamma.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Developed by Santosh Thapa
      </a>
    </div>

    <div className={styles.copyright}>
      <span>{new Date().getFullYear()}</span>
      <strong> Geer</strong>
    </div>
  </footer>
);
export default Footer;
